module.exports = __webpack_public_path__ + "img/bg_home1.a921fb0d.png";